
import {
  Calendar,
  Clock,
  Info,
  User,
  Stethoscope,
  FileText,
  AlertCircle,
  CheckCircle,
  ChevronLeft,
  ChevronRight,
  Heart,
  CreditCard,
  Star,
  ArrowLeft,
  ArrowRight,
} from "lucide-react";

export const appointmentTypes = [
    { value: "checkup", label: "General Checkup", icon: "🏥" },
    { value: "vaccination", label: "Vaccination", icon: "💉" },
    { value: "surgery", label: "Surgery", icon: "🔬" },
    { value: "consultation", label: "Consultation", icon: "💬" },
    { value: "emergency", label: "Emergency", icon: "🚨" },
    { value: "grooming", label: "Grooming", icon: "✂️" },
    { value: "dental", label: "Dental Care", icon: "🦷" },
    { value: "follow-up", label: "Follow-up", icon: "📋" },
  ];


  export const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  // Time slots
  export const timeSlots = [
    "08:00",
    "08:30",
    "09:00",
    "09:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
  ];

  export const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  
 export const steps = [
      { number: 1, title: "Select Pet", icon: Heart },
      { number: 2, title: "Appointment", icon: Stethoscope },
      { number: 3, title: "Date & Time", icon: Calendar },
      { number: 4, title: "Doctors", icon: User },
      { number: 5, title: "Details", icon: FileText },
      { number: 6, title: "Payment", icon: CreditCard },
      { number: 7, title: "Confirmation", icon: CheckCircle },
    ];